<template>
  <div>
    <v-card outlined style='border-radius: 5px'>
      <v-card-title primary-title class='white white--text py-2 justify-center'>
        Entradas e saídas
      </v-card-title>

      <card-loading-transparent v-if="loading"/>
      <v-card-text class="mt-3" v-if="!loading">
        <v-progress-linear style='border-radius: 5px' :value="calculate" height="25" background-color="error" color="success">
          <template v-slot:default="{ value }">
            <strong>{{calculate.toFixed(2)}}%</strong>
          </template>
        </v-progress-linear>
        <v-row>
          <v-col align="left">
            <div>
              <span class="headline font-weight-black success--text mt-1">
                {{formatMoney(income)}}
              </span>
              <span class="font-weight-black success--text">
                Entradas
              </span>
            </div>
          </v-col>
          <v-col align="center">
            <div>
              <span class="headline font-weight-black black--text mt-1">
                {{formatMoney(income - outcome)}}
              </span>
              <span class="font-weight-black black--text">
                Saldo Mensal
              </span>
            </div>
          </v-col>
          <v-col align="right">
            <div>
              <span class="headline font-weight-black error--text mt-1">
                {{formatMoney(outcome)}}
              </span>
              <span class="font-weight-black error--text">
                Saídas
              </span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>
  </div>
</template>

<script>
import Api from '@/api'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProfitAndLoss',

  props: {
    start_date: {
      type: String,
      default: ()=>null
    },
    end_date: {
      type: String,
      default: ()=>null
    }
  },

  data() {
    return {
      income: 0,
      outcome: 0,
      loading: false
    }
  },
  methods: {
    formatMoney(income){
      //let format_style = Intl.NumberFormat('pt-BR');
      return Number(income).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      //return format_style.format(income);
    },
    getData(){
      this.loading = true
      let filter = {
        // status: 'payed',
        // company_id: this.activeCompanyId,
        start_date: this.start_date != '' ? this.start_date : this.$dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        end_date: this.end_date != '' ? this.end_date : this.$dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
      }
      Api.DashCounter.showByCompany(this.activeCompanyId, 'income_outcome', filter).then(r=>r.data).then(d=>{
        this.income = d.income || 0
        this.outcome = d.outcome || 0
        this.income = this.income/100
        this.outcome = this.outcome/100
      }).catch((err) => {
        console.log(err);
      }).finally(()=>{
        this.loading = false
      })
    }
  },

  computed: {
    calculate() {
      let percentage = ((this.income / (this.income + this.outcome))||0) * 100
      return percentage
    },
    ...mapState({
      activeCompanyId: state => state.App.activeCompanyId
    }),
    
  },

  mounted () {
    this.getData()
  },
  watch: {
    start_date(){
      this.getData()
    },
    activeCompanyId(){
      this.getData()
    }
  },

}
</script>

<style lang="scss" scoped>

</style>